import {RefundStatusEnum} from 'domain/usecases/private/refund/consult-refunds/get-refund-protocol-status';

function refundProtocolStatusParser(
	status: RefundStatusEnum,
	statuses: Record<RefundStatusEnum, string>,
): string {
	return statuses[status] || '';
}

export {refundProtocolStatusParser};
